import { changelog } from "changelog";
import { APP_VERSION } from "config/appVersion";
import { useTranslation } from "i18n";

import "./style.css";

const getVersionEntries = () =>
  Object.entries(changelog).sort(([versionA], [versionB]) =>
    versionB.localeCompare(versionA, undefined, { numeric: true })
  );

const ChangelogPage = () => {
  const { locale, t } = useTranslation();
  const versions = getVersionEntries();

  return (
    <main className="changelog-page">
      <div className="changelog-page__inner">
        <header className="changelog-page__header">
          <p className="changelog-page__eyebrow">{t("changelog.eyebrow")}</p>
          <h1>{t("changelog.title")}</h1>
          <p className="changelog-page__lead">{t("changelog.description")}</p>
          <p className="changelog-page__current">
            {t("changelog.current", { version: APP_VERSION })}
          </p>
        </header>

        <div className="changelog-page__timeline">
          {versions.map(([version, release], index) => {
            const copy = release?.[locale] || release?.en;
            const isLatest = index === 0;
            const count = copy?.items?.length || 0;

            return (
              <article
                className={`changelog-page__card${isLatest ? " is-latest" : ""}`}
                key={version}
              >
                <div className="changelog-page__card-head">
                  <div>
                    <h2>{t("footer.version", { version })}</h2>
                    <p>
                      {t("changelog.changeCount", { count })}
                    </p>
                  </div>
                  {isLatest && (
                    <span className="changelog-page__badge">
                      {t("changelog.latest")}
                    </span>
                  )}
                </div>
                <ul className="changelog-page__list">
                  {copy?.items?.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </article>
            );
          })}
        </div>
      </div>
    </main>
  );
};

export default ChangelogPage;
